// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"7ad25c2f","259":"7ad25c2f","566":"7ad25c2f","933":"7ad25c2f"}[chunkId] + ".chunk.css";
};